import { useEffect, useState } from "react";
import { api } from "../api.js";
import { ErrorBox, VerdictPill } from "../components/helpers.jsx";
import { useAuth } from "../auth.jsx";

function Stat({ title, value, sub }) {
    return (
        <div className="card">
            <h2>{title}</h2>
            <div className="big">{value?.toLocaleString?.() ?? value ?? "—"}</div>
            {sub && <div className="sub">{sub}</div>}
        </div>
    );
}

export default function Overview() {
    const { me } = useAuth();
    const [stats, setStats] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/stats")
            .then((s) => { if (alive) setStats(s); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, []);

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Overview</h1>
                    <div className="sub">
                        {me?.role === "super"
                            ? "Across every tenant on this server"
                            : `Your tenant — last 24 hours`}
                    </div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>

            {stats && (
                <>
                    <div className="grid cols-4">
                        <Stat title="Active sessions" value={stats.activeSessions} sub={`${stats.sessions24h} started in 24h`} />
                        <Stat title="Attempts (24h)" value={stats.attempts24h} sub={`${stats.attemptsTotal?.toLocaleString()} total`} />
                        <Stat title="Bans (24h)"     value={stats.bans24h}     sub={`${stats.activeBans} active`} />
                        <Stat title="Denies (24h)"   value={stats.denies24h} />
                    </div>
                    <div className="grid cols-4" style={{ marginTop: 12 }}>
                        <Stat title="Subjects seen"  value={stats.subjectsSeen} sub={`${stats.hwidBanSubjects} hwid-banned`} />
                        <Stat title="HWID-ban rows"  value={stats.hwidBanRows} />
                    </div>

                    <div className="grid cols-2" style={{ marginTop: 12 }}>
                        <div className="card">
                            <h2>Verdict breakdown (24h)</h2>
                            <table className="data" style={{ marginTop: 8 }}>
                                <tbody>
                                    {(stats.verdictBreakdown ?? []).length === 0 && (
                                        <tr><td className="text-dim">No data yet</td></tr>
                                    )}
                                    {(stats.verdictBreakdown ?? []).map((r) => (
                                        <tr key={r.verdict}>
                                            <td><VerdictPill verdict={r.verdict} /></td>
                                            <td className="mono">{r.n.toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="card">
                            <h2>Top categories (24h)</h2>
                            <table className="data" style={{ marginTop: 8 }}>
                                <tbody>
                                    {(stats.topCategories ?? []).length === 0 && (
                                        <tr><td className="text-dim">No flags yet</td></tr>
                                    )}
                                    {(stats.topCategories ?? []).map((r) => (
                                        <tr key={r.category}>
                                            <td>{r.category}</td>
                                            <td className="mono">{r.n.toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {me?.role === "super" && (
                        <div className="grid cols-2" style={{ marginTop: 12 }}>
                            <Stat title="Admin logins (24h)" value={stats.adminLogins24h ?? 0}
                                  sub={`${stats.failedLogins24h ?? 0} failed`} />
                        </div>
                    )}
                </>
            )}
        </>
    );
}
